module.exports = __webpack_public_path__ + "static/img/jieshu.87245ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jieshu.png
// module id = 26pz
// module chunks = 171